import React from 'react'

const LoadingScreen = () => {
    return (<div style={{height:"600px", display:"grid", justifyContent:"space-evenly", alignContent:"space-evenly"}}>
        Loading Contents...
    </div>)
}

export default LoadingScreen;